<template>
    <div class="title-container">
        <div class="title-main">
            <div class="title-default">
                <h2 class="title" :class="breadSubTitle ? 'parent' : ''" @click="handleTitle">{{ title }}</h2>
                <template v-if="breadSubTitle">
                    <div class="right-icon">
                        <Icon name="el-icon-ArrowRight" size="16" />
                    </div>
                    <h3 class="title">{{ breadSubTitle }}</h3>
                </template>
                <Icon size="20" color="#296ce9" name="fa fa-chevron-circle-right" />
            </div>
            <div class="title-desc">{{ desc }}</div>
        </div>
        <div class="title-extend">
            <slot name="right"></slot>
            <div class="title-default right-box" v-if="ruleDescription">
                <div class="wenhao-icon">
                    <Icon name="iconfont icon-wenhao" />
                </div>
                <div>{{ ruleDescription }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
// 定义属性接口
interface Props {
    title?: string
    desc?: string
    breadSubTitle?: string
    ruleDescription?: string
    isForm?: boolean
    tips?: string
    backUrl?: string
}

// 接收父组件传递的属性
const props = withDefaults(defineProps<Props>(), {
    isForm: false,
    tips: '当前表单信息未提交，是否放弃提交',
})

const router = useRouter()

/**
 * 返回上一级页面
 */
const handleTitle = () => {
    if (props.breadSubTitle) {
        // 存在二级标题
        if (props.isForm) {
            // 表单状态 弹出提示
            ElMessageBox.confirm(props.tips, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
            })
                .then(() => props.backUrl ? router.replace(props.backUrl) : router.back())
                .catch(() => {})
        } else {
            props.backUrl ? router.replace(props.backUrl) : router.back()
        }
    }
}
</script>

<style scoped lang="scss">
.title-container {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}

.title-default {
    display: flex;
    align-items: center;
}

.title {
    font-size: 18px;
    margin-right: 5px;
}

.parent {
    cursor: pointer;
    transition: color 0.2s ease;
    &:hover {
        color: #1e90ff;
    }
}

.title-desc {
    margin-top: 5px;
    font-size: 12px;
    color: #777;
}

.right-icon {
    margin: 3px 8px 0;
}

.wenhao-icon {
    margin: 2px 4px 0 0;
}

.right-box {
    font-size: 14px;
}
</style>
